module.exports = __webpack_public_path__ + "img/2.f85d0af2.png";